import { useState } from 'react'

export function useZoom() {
  const [zoomLevel, setZoomLevel] = useState(4)
  const canZoomIn = zoomLevel > 1
  const canZoomOut = zoomLevel < 4
  const fitToWidth = zoomLevel === 1

  const zoomIn = () => {
    setZoomLevel((prev) => prev - 1)
  }
  const zoomOut = () => {
    setZoomLevel((prev) => prev + 1)
  }

  const onFitToWidth = () => {
    if (zoomLevel === 1) {
      setZoomLevel(4)
    } else {
      setZoomLevel(1)
    }
  }

  return {
    zoomLevel,
    canZoomIn,
    canZoomOut,
    zoomIn,
    zoomOut,
    fitToWidth,
    onFitToWidth,
    setZoomLevel,
  }
}
